<template>
  <section class="section">
    <div class="section-body">
      <div
        class="card"
        v-if="
          !isEdit && mode != 'increase' && mode != 'edit' && mode != 'editFlie'
        "
      >
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.academicYear") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.semester") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationYear") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control" v-model="selectedYear">
                        <option
                          v-for="(opt, idx) in selectedYearOpts"
                          v-bind:key="idx"
                          v-bind:value="opt.value"
                        >
                          {{ opt.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentChanged"
                      :facultyid="selFaculty"
                      :selectedVal="selDepartment"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="txtProgramCode"
                                  @keypress="handleSearchProgramKey($event)"
                                />
                                <button
                                  class="btn btn-primary btn-lg"
                                  type="button"
                                  @click="handleSearchProgram()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramName"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearSelectProgram()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.yearPlan") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearPlanChanged"
                      :selectedVal="selYearPlan"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.prevTerm") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelPrevTermChanged"
                      :selectedVal="selPrevTerm"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="txtStudentCodeFrom"
                                  @keypress="handleSearchStudentFromKey($event)"
                                />
                                <button
                                  class="btn btn-primary btn-lg"
                                  type="button"
                                  @click="openDialogSearch('from')"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameFrom"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentFrom()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="txtStudentCodeTo"
                                  @keypress="handleSearchStudentToKey($event)"
                                />
                                <button
                                  class="btn btn-primary btn-lg"
                                  type="button"
                                  @click="openDialogSearch('to')"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameTo"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentTo()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div
                    class="col no-margin-padding"
                    style="flex: 0 0 10em;"
                  ></div>
                  <div class="col no-margin-padding mt-5">
                    <div class="form-row">
                      <div class="form-group" style="width: 100%">
                        <input
                          type="checkbox"
                          id="chk"
                          v-model="chkCondition"
                        />
                        <label
                          >&nbsp;&nbsp;&nbsp;{{
                            $t("messages.general.insertCondition")
                          }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-row">
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      >
                        <label>{{ $t("messages.general.selStuGroup") }}</label>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 18em;"
                      >
                        <input
                          type="file"
                          ref="csvFile"
                          class="form-control"
                          @change="handleCsvFileChg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline">
                     <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleSearchConfirmResult()"
                      >
                        {{ $t("messages.general.search") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="increase()"
                      >
                        {{ $t("messages.general.increase") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-light btn-lg"
                        @click="clearAll()"
                      >
                        {{ $t("messages.general.clearScreen") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button" 
                       class="btn  btn-primary btn-lg"
                        @click="handleChkSetStudent()"
                        :disabled="this.studentConditonList.length <= 1"
                      >
                        {{ $t("messages.general.regischkAll") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                  <div
                    class="form-group"
                    style="width: 40%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-danger btn-lg"
                        @click="handleClearDataTablePopup()"
                      >
                        {{ $t("messages.general.clearDataTable") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(actionChk)="">
                <input
                  type="checkbox"
                  id="chkStudentAll"
                  @change="handleChkAllStudent($event)"
                  :checked="
                    bTable.items.length > 0 &&
                      bTable.items.length == studentConditonList.length
                  "
                />
              </template>
              <template v-slot:cell(actionChk)="data">
                <input
                  type="checkbox"
                  id="chkStudent"
                  @change="handleChkStudent($event, data)"
                  :checked="data.item.selCheck"
                />
              </template>
              <template v-slot:cell(actionEdit)="data">
                <v-btn
                  text
                  icon
                  @click="handleTableEdit(data.item, data.index, 'edit')"
                >
                  <v-icon
                    @click="handleTableEdit(data.item, data.index, 'edit')"
                    >edit</v-icon
                  >
                </v-btn>
                <v-btn text icon @click="handleDeleteStuError(data)">
                  <v-icon> delete</v-icon>
                </v-btn>
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="!isEdit && mode == 'increase'">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.academicYear") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    {{ this.selYear }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.semester") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    {{ this.selSemester }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationYear") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control" v-model="selectedYear">
                        <option
                          v-for="(opt, idx) in selectedYearOpts"
                          v-bind:key="idx"
                          v-bind:value="opt.value"
                        >
                          {{ opt.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentChanged"
                      :facultyid="selFaculty"
                      :selectedVal="selDepartment"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramCode"
                              @keypress="handleSearchProgramKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="handleSearchProgram()"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramName"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearSelectProgram()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.yearPlan") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearPlanChanged"
                      :selectedVal="selYearPlan"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.prevTerm") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelPrevTermChanged"
                      :selectedVal="selPrevTerm"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentCodeFrom"
                              @keypress="handleSearchStudentFromKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="openDialogSearch('from')"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameFrom"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentFrom()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentCodeTo"
                              @keypress="handleSearchStudentToKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="openDialogSearch('to')"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameTo"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentTo()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResultStudent()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="clearAllIncrease()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="goBackIncrease()"
                  >
                    {{ $t("messages.general.backhome") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <v-tabs v-model="selTabIncrease">
              <v-tab href="#tabincrease-1">{{
                $t("messages.general.studentListName")
              }}</v-tab>
              <v-tab href="#tabincrease-2">{{
                $t("messages.general.conditionsCtrlEnrollment")
              }}</v-tab>
              <v-tab-item value="tabincrease-1">
                <div class="table-responsive">
                  <v-card>
                    <b-table
                      bordered
                      hover
                      small
                      responsive
                      caption-top
                      class="table table-striped text-center"
                      :sort-by.sync="bTableStudent.sortBy"
                      :sort-desc.sync="bTableStudent.sortDesc"
                      :items="bTableStudent.items"
                      :fields="bTableStudent.fields"
                      :per-page="perPage"
                      :current-page="currentPage"
                    >
                      <template slot="table-caption">
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPage"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableStudent.items.length"
                          v-model="currentPage"
                          :per-page="perPage"
                        />
                        <div
                          v-if="bTableStudent.items.length > 0"
                          class="float-right data-table-page-info"
                        >
                          {{
                            Number(
                              currentPage > 1
                                ? (currentPage - 1) * perPage + 1
                                : currentPage
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPage * perPage > bTableStudent.items.length
                                ? bTableStudent.items.length
                                : currentPage * perPage
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableStudent.items.length).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableStudent.items.length <= 0"
                          class="float-right data-table-page-info"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableStudent.items.length).toLocaleString()
                          }}
                        </div>
                      </template>
                      <template v-slot:cell(editaction)="data">
                        <v-btn
                          text
                          icon
                          @click="goTo(data.item, data.index, 'edit')"
                        >
                          <v-icon @click="goTo(data.item, data.index, 'edit')"
                            >edit</v-icon
                          >
                        </v-btn>
                      </template>

                      <template v-slot:head(action)="">
                        <input
                          type="checkbox"
                          id="chkStuAll"
                          @change="handleChkStuAll($event)"
                          :checked="
                            bTableStudent.items.length > 0 &&
                              bTableStudent.items.length ==
                                studentUnapproveListAdd.length
                          "
                        />
                      </template>

                      <template v-slot:cell(action)="data">
                        <input
                          type="checkbox"
                          id="chkStu"
                          @change="handleChkStu($event, data)"
                          :checked="data.value"
                        />
                      </template>

                      <template slot="table-caption">
                        <div
                          style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                        >
                          <div class="float-left">
                            <b class="mr-2">{{
                              $t("messages.general.table.paginationinfo")
                            }}</b>
                            <b-form-select
                              v-model="perPage"
                              :options="perPageOptions"
                              size="sm"
                              style="width:70px"
                            />
                          </div>
                          <b-pagination
                            class="float-right"
                            size="sm"
                            :total-rows="bTableStudent.items.length"
                            v-model="currentPage"
                            :per-page="perPage"
                            style="padding-top: 10px"
                          />
                          <div
                            v-if="bTableStudent.items.length > 0"
                            class="float-right data-table-page-info"
                            style="padding-top: 14px"
                          >
                            {{
                              Number(
                                currentPage > 1
                                  ? (currentPage - 1) * perPage + 1
                                  : currentPage
                              ).toLocaleString()
                            }}
                            -
                            {{
                              Number(
                                currentPage * perPage >
                                  bTableStudent.items.length
                                  ? bTableStudent.items.length
                                  : currentPage * perPage
                              ).toLocaleString()
                            }}
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableStudent.items.length
                              ).toLocaleString()
                            }}
                          </div>
                          <div
                            v-if="bTableStudent.items.length <= 0"
                            class="float-right data-table-page-info"
                            style="padding-top: 14px"
                          >
                            0 - 0
                            {{ $t("messages.general.fromRecords") }}
                            {{
                              Number(
                                bTableStudent.items.length
                              ).toLocaleString()
                            }}
                          </div>
                        </div>
                      </template>
                    </b-table>
                  </v-card>
                </div>
              </v-tab-item>
              <v-tab-item value="tabincrease-2">
                <div class="form-row">
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div class="col no-margin-padding">
                        <select class="form-control" @change="handleSelErrChg">
                          <option value="-1" :selected="selErrorId == -1"
                            >---{{
                              $t("messages.general.notSpecified")
                            }}---</option
                          >
                          <option
                            v-for="(item, index) in masterConditionList"
                            :key="index"
                            :value="item.ERRORID"
                            :selected="selErrorId == item.ERRORID"
                          >
                            {{ `${item.ERRORID}: ${item.ERRORSTRING}` }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em; text-align: right;"
                      >
                        <button
                          type="button"
                          class="btn btn-primary btn-lg"
                          @click="handleSaveErrorCondition"
                        >
                          {{ $t("messages.general.save") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    selErrorItem.ERROR_DETAIL == 'C1' ||
                      selErrorItem.ERROR_DETAIL == 'C2'
                  "
                  class="form-row"
                >
                  <div class="col no-padding-bottom">
                    <div class="form-row">
                      <div
                        class="col no-padding-bottom"
                        style="padding-right: 10px !important"
                      >
                        <div class="information-detail-white">
                          <div
                            class="col no-margin-padding"
                            style="flex: 0 0 16em;"
                          >
                            <label>{{
                              `${$t("messages.general.moreDetail")} ${$t(
                                "messages.general.classId"
                              )}1`
                            }}</label>
                          </div>
                          <div class="col no-margin-padding">
                            <div class="form-row">
                              <div class="col no-padding-bottom">
                                <div class="information-detail-white">
                                  <div class="col no-margin-padding">
                                    <div class="form-row">
                                      <div
                                        class="col no-margin-padding"
                                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                                      >
                                        <div
                                          class="form-group"
                                          style="margin-bottom: 0;"
                                        >
                                          <div class="form-inline">
                                            <input
                                              type="text"
                                              class="form-control col mr-2"
                                              style="margin-right: 0px !important"
                                              v-model="courseCode"
                                              @keypress="
                                                handleSearchClsKey($event, 1)
                                              "
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-temp btn-lg"
                                              @click="handleSearchCls(1)"
                                            >
                                              <i class="fas fa-search"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col no-margin-padding"
                                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                                      >
                                        <div
                                          class="form-group"
                                          style="margin-bottom: 0;"
                                        >
                                          <div class="form-inline">
                                            <input
                                              type="text"
                                              class="form-control col mr-2"
                                              style="margin-right: 0px !important"
                                              disabled
                                              v-model="courseName"
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-danger btn-lg"
                                              @click="handleClrScreen()"
                                            >
                                              <i class="fas fa-trash"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="selErrorItem.ERROR_DETAIL == 'C2' || selErrorItem.ERRORID == 5101" class="form-row">
                  <div class="col no-padding-bottom">
                    <div class="form-row">
                      <div
                        class="col no-padding-bottom"
                        style="padding-right: 10px !important"
                      >
                        <div class="information-detail-white">
                          <div
                            class="col no-margin-padding"
                            style="flex: 0 0 16em;"
                          >
                            <label>{{
                              `${$t("messages.general.moreDetail")} ${$t(
                                "messages.general.classId"
                              )}2`
                            }}</label>
                          </div>
                          <div class="col no-margin-padding">
                            <div class="form-row">
                              <div class="col no-margin-padding">
                                <div class="information-detail-white">
                                  <div class="col no-margin-padding">
                                    <div class="form-row">
                                      <div
                                        class="col no-margin-padding"
                                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                                      >
                                        <div
                                          class="form-group"
                                          style="margin-bottom: 0;"
                                        >
                                          <div class="form-inline">
                                            <input
                                              type="text"
                                              class="form-control col mr-2"
                                              style="margin-right: 0px !important"
                                              v-model="courseCode2"
                                              @keypress="
                                                handleSearchClsKey($event, 2)
                                              "
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-temp btn-lg"
                                              @click="handleSearchCls(2)"
                                            >
                                              <i class="fas fa-search"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="col no-margin-padding"
                                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                                      >
                                        <div
                                          class="form-group"
                                          style="margin-bottom: 0;"
                                        >
                                          <div class="form-inline">
                                            <input
                                              type="text"
                                              class="form-control col mr-2"
                                              style="margin-right: 0px !important"
                                              disabled
                                              v-model="courseName2"
                                            />
                                            <button
                                              type="button"
                                              class="btn btn-danger btn-lg"
                                              @click="handleClrScreen2()"
                                            >
                                              <i class="fas fa-trash"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    selErrorItem.ERROR_DETAIL == 'CM' ||
                      selErrorItem.ERROR_DETAIL == 'CN'
                  "
                  class="form-row"
                >
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      >
                        <label>{{ $t("messages.general.moreDetail") }}</label>
                      </div>
                      <div class="col no-margin-padding">
                        <input
                          type="number"
                          class="form-control col"
                          style="margin-right: 0px !important"
                          v-model="errorCMCNTxt"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs>
          </form>
        </div>
      </div>

      <div class="card" v-if="!isEdit && mode == 'editFlie'">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0"></p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0"></p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block"></div>
          <div class="row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <div>{{ $t("messages.general.academicYear") }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div>{{ this.selYear }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <div>{{ $t("messages.general.semester") }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div>{{ this.selSemester }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="padding: 20px">
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableStudentFlieExcelList.sortBy"
                :sort-desc.sync="bTableStudentFlieExcelList.sortDesc"
                :items="bTableStudentFlieExcelList.items"
                :fields="bTableStudentFlieExcelList.fields"
                :per-page="perPage"
                :current-page="currentPage"
              >
              </b-table>
            </v-card>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-light btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding">
                  <select class="form-control" @change="handleSelErrChg">
                    <option value="-1" :selected="selErrorId == -1"
                      >---{{ $t("messages.general.notSpecified") }}---</option
                    >
                    <option
                      v-for="(item, index) in masterConditionList"
                      :key="index"
                      :value="item.ERRORID"
                      :selected="selErrorId == item.ERRORID"
                    >
                      {{ `${item.ERRORID}: ${item.ERRORSTRING}` }}
                    </option>
                  </select>
                </div>
                <div
                  class="col no-margin-padding"
                  style="flex: 0 0 10em; text-align: right;"
                >
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSaveFlieAdjustConditionlist"
                  >
                    {{ $t("messages.general.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selErrorItem.ERROR_DETAIL == 'C1' ||
                selErrorItem.ERROR_DETAIL == 'C2'
            "
            class="form-row"
          >
            <div class="col no-padding-bottom">
              <div class="form-row">
                <div
                  class="col no-padding-bottom"
                  style="padding-right: 10px !important"
                >
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <label>{{
                        `${$t("messages.general.moreDetail")} ${$t(
                          "messages.general.classId"
                        )}1`
                      }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div class="form-row">
                        <div class="col no-margin-padding">
                          <div class="information-detail-white">
                            <div class="col no-margin-padding">
                              <div class="form-row">
                                <div
                                  class="col no-margin-padding"
                                  style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="input-group">
                                      <div class="form-inline">
                                        <div class="input-group-append">
                                          <input
                                            type="text"
                                            class="form-control col mr-2"
                                            style="margin-right: 0px !important"
                                            v-model="courseCode"
                                            @keypress="
                                              handleSearchClsKey($event, 1)
                                            "
                                          />
                                          <button
                                            type="button"
                                            class="btn btn-temp btn-lg"
                                            @click="handleSearchCls(1)"
                                          >
                                            <i class="fas fa-search"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col no-margin-padding"
                                  style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="form-inline">
                                      <input
                                        type="text"
                                        class="form-control col mr-2"
                                        style="margin-right: 0px !important"
                                        disabled
                                        v-model="courseName"
                                      />
                                      <button
                                        type="button"
                                        class="btn btn-danger btn-lg"
                                        @click="handleClrScreen()"
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selErrorItem.ERROR_DETAIL == 'C2' || selErrorItem.ERRORID == 5101
            "
            class="form-row"
          >
            <div class="col no-padding-bottom">
              <div class="form-row">
                <div
                  class="col no-padding-bottom"
                  style="padding-right: 10px !important"
                >
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <label>{{
                        `${$t("messages.general.moreDetail")} ${$t(
                          "messages.general.classId"
                        )}2`
                      }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div class="form-row">
                        <div class="col no-margin-padding">
                          <div class="information-detail-white">
                            <div class="col no-margin-padding">
                              <div class="form-row">
                                <div
                                  class="col no-margin-padding"
                                  style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="input-group">
                                      <div class="form-inline">
                                        <div class="input-group-append">
                                          <input
                                            type="text"
                                            class="form-control col mr-2"
                                            style="margin-right: 0px !important"
                                            v-model="courseCode2"
                                            @keypress="
                                              handleSearchClsKey($event, 2)
                                            "
                                          />
                                          <button
                                            type="button"
                                            class="btn btn-temp btn-lg"
                                            @click="handleSearchCls(2)"
                                          >
                                            <i class="fas fa-search"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col no-margin-padding"
                                  style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="form-inline">
                                      <input
                                        type="text"
                                        class="form-control col mr-2"
                                        style="margin-right: 0px !important"
                                        disabled
                                        v-model="courseName2"
                                      />
                                      <button
                                        type="button"
                                        class="btn btn-danger btn-lg"
                                        @click="handleClrScreen2()"
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selErrorItem.ERROR_DETAIL == 'CM' ||
                selErrorItem.ERROR_DETAIL == 'CN'
            "
            class="form-row"
          >
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.moreDetail") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <input
                    type="number"
                    min="0"
                    class="form-control col"
                    style="margin-right: 0px !important"
                    v-model="errorCMCNTxt"
                  />
                </div>
              </div>
            </div>
          </div>
          <br />
        </form>
      </div>
      <div class="card" v-if="!isEdit && mode == 'edit'">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0"></p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0"></p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block"></div>
          <div class="row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <div>{{ $t("messages.general.academicYear") }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div>{{ this.selYear }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <div>{{ $t("messages.general.semester") }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div>{{ this.selSemester }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="this.studentConditonList.length <= 1">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <div>{{ $t("messages.general.identity") }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div>{{ selected.STUDENTCODE }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="this.studentConditonList.length <= 1">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 16em;">
                  <div>{{ $t("messages.general.fullname") }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div>{{ selected.STUDENTNAME }}</div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
                <div class="col no-margin-padding">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else style="padding: 20px">
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableStuList.sortBy"
                :sort-desc.sync="bTableStuList.sortDesc"
                :items="bTableStuList.items"
                :fields="bTableStuList.fields"
                :per-page="perPage"
                :current-page="currentPage"
              >
              </b-table>
            </v-card>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-light btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding">
                  <select class="form-control" @change="handleSelErrChg">
                    <option value="-1" :selected="selErrorId == -1"
                      >---{{ $t("messages.general.notSpecified") }}---</option
                    >
                    <option
                      v-for="(item, index) in masterConditionList"
                      :key="index"
                      :value="item.ERRORID"
                      :selected="selErrorId == item.ERRORID"
                    >
                      {{ `${item.ERRORID}: ${item.ERRORSTRING}` }}
                    </option>
                  </select>
                </div>
                <div
                  class="col no-margin-padding"
                  style="flex: 0 0 10em; text-align: right;"
                >
                  <!--ปุ่มบันทึก หน้า edit-->
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSaveAdjustCondition"
                  >
                    {{ $t("messages.general.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selErrorItem.ERROR_DETAIL == 'C1' ||
                selErrorItem.ERROR_DETAIL == 'C2'
            "
            class="form-row"
          >
            <div class="col no-padding-bottom">
              <div class="form-row">
                <div
                  class="col no-padding-bottom"
                  style="padding-right: 10px !important"
                >
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <label>{{
                        `${$t("messages.general.moreDetail")} ${$t(
                          "messages.general.classId"
                        )}1`
                      }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div class="form-row">
                        <div class="col no-margin-padding">
                          <div class="information-detail-white">
                            <div class="col no-margin-padding">
                              <div class="form-row">
                                <div
                                  class="col no-margin-padding"
                                  style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="input-group">
                                      <div class="form-inline">
                                        <div class="input-group-append">
                                          <input
                                            type="text"
                                            class="form-control col mr-2"
                                            style="margin-right: 0px !important"
                                            v-model="courseCode"
                                            @keypress="
                                              handleSearchClsKey($event, 1)
                                            "
                                          />
                                          <button
                                            type="button"
                                            class="btn btn-temp btn-lg"
                                            @click="handleSearchCls(1)"
                                          >
                                            <i class="fas fa-search"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col no-margin-padding"
                                  style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="form-inline">
                                      <input
                                        type="text"
                                        class="form-control col mr-2"
                                        style="margin-right: 0px !important"
                                        disabled
                                        v-model="courseName"
                                      />
                                      <button
                                        type="button"
                                        class="btn btn-danger btn-lg"
                                        @click="handleClrScreen()"
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selErrorItem.ERROR_DETAIL == 'C2' || selErrorItem.ERRORID == 5101
            "
            class="form-row"
          >
            <div class="col no-padding-bottom">
              <div class="form-row">
                <div
                  class="col no-padding-bottom"
                  style="padding-right: 10px !important"
                >
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <label>{{
                        `${$t("messages.general.moreDetail")} ${$t(
                          "messages.general.classId"
                        )}2`
                      }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div class="form-row">
                        <div class="col no-margin-padding">
                          <div class="information-detail-white">
                            <div class="col no-margin-padding">
                              <div class="form-row">
                                <div
                                  class="col no-margin-padding"
                                  style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="input-group">
                                      <div class="form-inline">
                                        <div class="input-group-append">
                                          <input
                                            type="text"
                                            class="form-control col mr-2"
                                            style="margin-right: 0px !important"
                                            v-model="courseCode2"
                                            @keypress="
                                              handleSearchClsKey($event, 2)
                                            "
                                          />
                                          <button
                                            type="button"
                                            class="btn btn-temp btn-lg"
                                            @click="handleSearchCls(2)"
                                          >
                                            <i class="fas fa-search"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col no-margin-padding"
                                  style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                                >
                                  <div
                                    class="form-group"
                                    style="margin-bottom: 0;"
                                  >
                                    <div class="form-inline">
                                      <input
                                        type="text"
                                        class="form-control col mr-2"
                                        style="margin-right: 0px !important"
                                        disabled
                                        v-model="courseName2"
                                      />
                                      <button
                                        type="button"
                                        class="btn btn-danger btn-lg"
                                        @click="handleClrScreen2()"
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selErrorItem.ERROR_DETAIL == 'CM' ||
                selErrorItem.ERROR_DETAIL == 'CN'
            "
            class="form-row"
          >
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.moreDetail") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <input
                    type="number"
                    min="0"
                    class="form-control col"
                    style="margin-right: 0px !important"
                    v-model="errorCMCNTxt"
                  />
                </div>
              </div>
            </div>
          </div>
          <br />
        </form>
        <v-tabs v-model="selTab" v-if="studentConditonList.length <= 1">
          <v-tab href="#tab-1">{{
            $t("messages.general.canceledConditionslist")
          }}</v-tab>
          <v-tab href="#tab-2">{{
            $t("messages.general.errorListAdjust")
          }}</v-tab>
          <v-tab-item value="tab-1">
            <!--Tab ตารางเงื่อนไขที่ได้รับการยกเลิก-->
            <div class="table-responsive">
              <v-card>
                <b-table
                  bordered
                  hover
                  small
                  responsive
                  caption-top
                  class="table table-striped text-center"
                  :sort-by.sync="bTableConditionlistbystd.sortBy"
                  :sort-desc.sync="bTableConditionlistbystd.sortDesc"
                  :items="bTableConditionlistbystd.items"
                  :fields="bTableConditionlistbystd.fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                >
                  <template slot="table-caption">
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableConditionlistbystd.items.length"
                      v-model="currentPage"
                      :per-page="perPage"
                    />
                    <div
                      v-if="bTableConditionlistbystd.items.length > 0"
                      class="float-right data-table-page-info"
                    >
                      {{
                        Number(
                          currentPage > 1
                            ? (currentPage - 1) * perPage + 1
                            : currentPage
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPage * perPage >
                            bTableConditionlistbystd.items.length
                            ? bTableConditionlistbystd.items.length
                            : currentPage * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableConditionlistbystd.items.length
                        ).toLocaleString()
                      }}
                    </div>
                    <div
                      v-if="bTableConditionlistbystd.items.length <= 0"
                      class="float-right data-table-page-info"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableConditionlistbystd.items.length
                        ).toLocaleString()
                      }}
                    </div>
                  </template>
                  <template v-slot:cell(ERROR_DETAIL)="data">
                    <div class="text-center">
                      <input
                        type="text"
                        class="form-control col mr-2"
                        style="text-align:right"
                        v-model="data.item.ERROR_DETAIL"
                        disabled
                      />
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <v-btn text icon @click="handleDeleteConditionbyStd(data)">
                      <v-icon> delete</v-icon>
                    </v-btn>
                  </template>
                  <template slot="table-caption">
                    <div
                      style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                    >
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableConditionlistbystd.items.length"
                        v-model="currentPage"
                        :per-page="perPage"
                        style="padding-top: 10px"
                      />
                      <div
                        v-if="bTableConditionlistbystd.items.length > 0"
                        class="float-right data-table-page-info"
                        style="padding-top: 14px"
                      >
                        {{
                          Number(
                            currentPage > 1
                              ? (currentPage - 1) * perPage + 1
                              : currentPage
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPage * perPage >
                              bTableConditionlistbystd.items.length
                              ? bTableConditionlistbystd.items.length
                              : currentPage * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(
                            bTableConditionlistbystd.items.length
                          ).toLocaleString()
                        }}
                      </div>
                      <div
                        v-if="bTableConditionlistbystd.items.length <= 0"
                        class="float-right data-table-page-info"
                        style="padding-top: 14px"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(
                            bTableConditionlistbystd.items.length
                          ).toLocaleString()
                        }}
                      </div>
                    </div>
                  </template>
                </b-table>
              </v-card>
            </div>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <!--Tab รายการ Error ที่เกิดขึ้น-->
            <div class="table-responsive">
              <v-card>
                <b-table
                  bordered
                  hover
                  small
                  responsive
                  caption-top
                  class="table table-striped text-center"
                  :sort-by.sync="bTableConditionerror.sortBy"
                  :sort-desc.sync="bTableConditionerror.sortDesc"
                  :items="bTableConditionerror.items"
                  :fields="bTableConditionerror.fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                >
                  <template slot="table-caption">
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableConditionerror.items.length"
                      v-model="currentPage"
                      :per-page="perPage"
                    />
                    <div
                      v-if="bTableConditionerror.items.length > 0"
                      class="float-right data-table-page-info"
                    >
                      {{
                        Number(
                          currentPage > 1
                            ? (currentPage - 1) * perPage + 1
                            : currentPage
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPage * perPage >
                            bTableConditionerror.items.length
                            ? bTableConditionerror.items.length
                            : currentPage * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableConditionerror.items.length
                        ).toLocaleString()
                      }}
                    </div>
                    <div
                      v-if="bTableConditionerror.items.length <= 0"
                      class="float-right data-table-page-info"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableConditionerror.items.length
                        ).toLocaleString()
                      }}
                    </div>
                  </template>
                  <template slot="table-caption">
                    <div
                      style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                    >
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableConditionerror.items.length"
                        v-model="currentPage"
                        :per-page="perPage"
                        style="padding-top: 10px"
                      />
                      <div
                        v-if="bTableConditionerror.items.length > 0"
                        class="float-right data-table-page-info"
                        style="padding-top: 14px"
                      >
                        {{
                          Number(
                            currentPage > 1
                              ? (currentPage - 1) * perPage + 1
                              : currentPage
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPage * perPage >
                              bTableConditionerror.items.length
                              ? bTableConditionerror.items.length
                              : currentPage * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(
                            bTableConditionerror.items.length
                          ).toLocaleString()
                        }}
                      </div>
                      <div
                        v-if="bTableConditionerror.items.length <= 0"
                        class="float-right data-table-page-info"
                        style="padding-top: 14px"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(
                            bTableConditionerror.items.length
                          ).toLocaleString()
                        }}
                      </div>
                    </div>
                  </template>
                </b-table>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs>
      </div>

      <v-dialog
        v-model="dialogSearchProgram"
        hide-overlay
        scrollable
        max-width="80%"
      >
        <v-card tile>
          <v-toolbar flat dense>
            <v-icon>search</v-icon>
            <v-toolbar-title>{{
              $t("messages.general.programNameList")
            }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogSearchProgram = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark>
            <form>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.programcode") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgProgramCode"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.programName") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgProgramName"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.faculty") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Faculty
                        :onChanged="onSelFacultyProgramChanged"
                        :selectedVal="selFacultyProgram"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.department") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Department
                        :onChanged="onSelDepartmentProgramChanged"
                        :facultyid="selFacultyProgram"
                        :selectedVal="selDepartmentProgram"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.educationLvl") }} </label>
                    </div>
                    <div class="col no-margin-padding">
                      <Level
                        :onChanged="onSelLvlProgramChanged"
                        :selectedVal="selLvlProgram"
                        :disabled="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.yearRef") }} </label>
                    </div>
                    <div class="col no-margin-padding">
                      <AcademicYear
                        :onChanged="onSelYearProgramChanged"
                        :selectedVal="selYearProgram"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row flex-column justify-content-center align-items-center mt-5"
              >
                <div class="form-group">
                  <div class="form-inline">
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      @click="handleProgramSearch(true)"
                    >
                      {{ $t("messages.general.search") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      class="btn btn-light btn-lg"
                      type="button"
                      @click="clearSearchProgram()"
                    >
                      {{ $t("messages.general.clearScreen") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </form>
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableProgram.sortBy"
                :sort-desc.sync="bTableProgram.sortDesc"
                :items="bTableProgram.items"
                :fields="bTableProgram.fields"
                :per-page="perPage"
                :current-page="currentPageProgram"
              >
                <template slot="table-caption">
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </template>

                <template v-slot:cell(PROGRAMCODE)="data">
                  <a
                    @click="handleSelectProgram(data.item, data.index)"
                    style="text-decoration: underline;"
                  >
                    {{ data.item.PROGRAMCODE }}
                  </a>
                </template>

                <template slot="table-caption">
                  <div
                    style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                  >
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableProgram.items.length"
                      v-model="currentPageProgram"
                      :per-page="perPage"
                      style="padding-top: 10px"
                    />
                    <div
                      v-if="bTableProgram.items.length > 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      {{
                        Number(
                          currentPageProgram > 1
                            ? (currentPageProgram - 1) * perPage + 1
                            : currentPageProgram
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPageProgram * perPage >
                            bTableProgram.items.length
                            ? bTableProgram.items.length
                            : currentPageProgram * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableProgram.items.length).toLocaleString() }}
                    </div>
                    <div
                      v-if="bTableProgram.items.length <= 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableProgram.items.length).toLocaleString() }}
                    </div>
                  </div>
                </template>
              </b-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSearch" hide-overlay scrollable max-width="80%">
        <v-card tile>
          <v-toolbar flat dense>
            <v-icon>search</v-icon>
            <v-toolbar-title>{{
              $t("messages.general.studentListName")
            }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogSearch = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark>
            <form>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.identity") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgSearchStudentId"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.fullname") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgSearchStudentName"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.faculty") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Faculty
                        :onChanged="onSelFacultySearchChanged"
                        :selectedVal="selFacultySearch"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.department") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Department
                        :onChanged="onSelDepartmentSearchChanged"
                        :facultyid="selFacultySearch"
                        :selectedVal="selDepartmentSearch"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.educationLvl") }} </label>
                    </div>
                    <div class="col no-margin-padding">
                      <Level
                        :onChanged="onSelLvlSearchChanged"
                        :selectedVal="selLvlSearch"
                        :disabled="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label
                        >{{ $t("messages.general.from") }}
                        {{ $t("messages.general.studentStatus") }}</label
                      >
                    </div>
                    <div class="col no-margin-padding">
                      <StudentStatus
                        :onChanged="onSelStudentStatusSearchFromChanged"
                        :selectedVal="selStudentStatusSearchFrom"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label
                        >{{ $t("messages.general.to") }}
                        {{ $t("messages.general.studentStatus") }}</label
                      >
                    </div>
                    <div class="col no-margin-padding">
                      <StudentStatus
                        :onChanged="onSelStudentStatusSearchToChanged"
                        :selectedVal="selStudentStatusSearchTo"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row flex-column justify-content-center align-items-center mt-5"
              >
                <div class="form-group">
                  <div class="form-inline">
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      @click="handleSearchStudentCode()"
                    >
                      {{ $t("messages.general.search") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      class="btn btn-light btn-lg"
                      type="button"
                      @click="cleartSearchStudentCode()"
                    >
                      {{ $t("messages.general.clearScreen") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </form>
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableSearch.sortBy"
                :sort-desc.sync="bTableSearch.sortDesc"
                :items="bTableSearch.items"
                :fields="bTableSearch.fields"
                :per-page="perPage"
                :current-page="currentPageSearch"
              >
                <template slot="table-caption">
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableSearch.items.length"
                    v-model="currentPageSearch"
                    :per-page="perPage"
                  />
                  <div
                    v-if="bTableSearch.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageSearch > 1
                          ? (currentPageSearch - 1) * perPage + 1
                          : currentPageSearch
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageSearch * perPage > bTableSearch.items.length
                          ? bTableSearch.items.length
                          : currentPageSearch * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableSearch.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableSearch.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableSearch.items.length).toLocaleString() }}
                  </div>
                </template>

                <template v-slot:cell(STUDENTID)="data">
                  <a
                    @click="handleSelectStudent(data.item, data.index)"
                    style="text-decoration: underline;"
                  >
                    {{ data.item.STUDENTID }}
                  </a>
                </template>

                <template slot="table-caption">
                  <div
                    style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                  >
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableSearch.items.length"
                      v-model="currentPageSearch"
                      :per-page="perPage"
                      style="padding-top: 10px"
                    />
                    <div
                      v-if="bTableSearch.items.length > 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      {{
                        Number(
                          currentPageSearch > 1
                            ? (currentPageSearch - 1) * perPage + 1
                            : currentPageSearch
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPageSearch * perPage >
                            bTableSearch.items.length
                            ? bTableSearch.items.length
                            : currentPageSearch * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableSearch.items.length).toLocaleString() }}
                    </div>
                    <div
                      v-if="bTableSearch.items.length <= 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableSearch.items.length).toLocaleString() }}
                    </div>
                  </div>
                </template>
              </b-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmDeleteTable" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense>
            <v-icon>delete</v-icon>
            <v-toolbar-title
              >&nbsp;{{
                $t("messages.general.clearDataTable")
              }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogConfirmDeleteTable = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="green accent-1">
            <br />
            <form>
              <div
                class="form-row flex-column justify-content-center align-items-center mt-5"
              >
                <div class="form-group">
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="handleClearDataTable()"
                    >
                      {{ $t("messages.general.confirm") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-light btn-lg"
                      @click="dialogConfirmDeleteTable = false"
                    >
                      {{ $t("messages.general.cancel") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense color="light-green accent-3">
            <v-icon color="light-green darken-2">fa-check</v-icon>
            <v-toolbar-title style="color: green;"
              >&nbsp;{{
                $t("messages.reqRegister.confirmPopupText")
              }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogConfirmSuccess = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="green accent-1">
            <br />
            <span v-html="successText" style="color: green;">{{
              successText
            }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogError" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense color="red darken-3">
            <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
            <v-toolbar-title style="color: #ffebee;"
              >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogError = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="red accent-1">
            <br />
            <span style="color: red;" v-html="errorText">{{ errorText }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSearchProgramCourse"
        hide-overlay
        scrollable
        max-width="80%"
      >
        <v-card tile>
          <v-toolbar flat dense>
            <v-icon>search</v-icon>
            <v-toolbar-title>{{
              $t("messages.general.classList")
            }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogSearchProgramCourse = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark>
            <form>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.classId") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgCourseCode"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.className") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgCourseName"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.faculty") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Faculty
                        :onChanged="onSelFacultyCourseChanged"
                        :selectedVal="selFacultyCourse"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.department") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Department
                        :onChanged="onSelDepartmentCourseChanged"
                        :facultyid="selFacultyCourse"
                        :selectedVal="selDepartmentCourse"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row flex-column justify-content-center align-items-center mt-5"
              >
                <div class="form-group">
                  <div class="form-inline">
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      @click="handleCourseSearch()"
                    >
                      {{ $t("messages.general.search") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      class="btn btn-light btn-lg"
                      type="button"
                      @click="clearCourseProgram()"
                    >
                      {{ $t("messages.general.clearScreen") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </form>
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableProgramCourse.sortBy"
                :sort-desc.sync="bTableProgramCourse.sortDesc"
                :items="bTableProgramCourse.items"
                :fields="bTableProgramCourse.fields"
                :per-page="perPage"
                :current-page="currentPageProgram"
              >
                <template slot="table-caption">
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgramCourse.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                  />
                  <div
                    v-if="bTableProgramCourse.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgramCourse.items.length
                          ? bTableProgramCourse.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableProgramCourse.items.length).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableProgramCourse.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableProgramCourse.items.length).toLocaleString()
                    }}
                  </div>
                </template>

                <template v-slot:cell(COURSECODE)="data">
                  <a
                    @click="handleSelectCourse(data.item, data.index)"
                    style="text-decoration: underline;"
                  >
                    {{ data.item.COURSECODE }}
                  </a>
                </template>

                <template slot="table-caption">
                  <div
                    style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                  >
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableProgramCourse.items.length"
                      v-model="currentPageProgram"
                      :per-page="perPage"
                      style="padding-top: 10px"
                    />
                    <div
                      v-if="bTableProgramCourse.items.length > 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      {{
                        Number(
                          currentPageProgram > 1
                            ? (currentPageProgram - 1) * perPage + 1
                            : currentPageProgram
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPageProgram * perPage >
                            bTableProgramCourse.items.length
                            ? bTableProgramCourse.items.length
                            : currentPageProgram * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableProgramCourse.items.length
                        ).toLocaleString()
                      }}
                    </div>
                    <div
                      v-if="bTableProgramCourse.items.length <= 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableProgramCourse.items.length
                        ).toLocaleString()
                      }}
                    </div>
                  </div>
                </template>
              </b-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { read, utils } from "xlsx";
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import StudentStatus from "@/components/Dropdown/StudentStatus.vue";
import EnrollProvider from "@/services/enroll_provider";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "setConditionCtrlEnroll",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    StudentStatus,
  },
  data() {
    return {
      selTab: "",
      dialogSearch: false,
      dialogSearchProgram: false,
      dialogSearchProgramCourse: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      selectedDetail: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      selDepartment: 0,
      isEdit: false,
      selFacultySearch: 0,
      selDepartmentSearch: 0,
      selLvlSearch: 0,
      selStudentStatusSearchFrom: 0,
      selStudentStatusSearchTo: 0,
      selYearPlan: 0,
      selPrevTerm: 0,
      selectedYear: 0,
      dialogConfirmSuccess: false,
      dialogConfirmDeleteTable: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      selectedYearOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ],
      studentUnapproveList: [],
      studentUnapproveListAdd: [],
      conditionList: [],
      bTableProgramCourse: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableConditionerror: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "ERRORID",
            label: this.$t("messages.general.idCondition"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "ERRORSTRING",
            label: this.$t("messages.general.condition"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            sortable: true,
          },
        ],
      },
      bTableConditionsCtrlEnroll: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "ERRORID",
            label: this.$t("messages.general.idCondition"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "ERRORSTRING",
            label: this.$t("messages.general.condition"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "ERROR_DETAIL",
            label: this.$t("messages.general.moreDetail"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 80px",
            sortable: true,
          },
        ],
      },
      bTableConditionlistbystd: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "ERRORID",
            label: this.$t("messages.general.idCondition"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "ERRORSTRING",
            label: this.$t("messages.general.condition"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "ERROR_DETAIL",
            label: this.$t("messages.general.moreDetail"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 80px",
            sortable: true,
          },
        ],
      },
      bTableStuList: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableStudentFlieExcelList: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
        ],
      },
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "actionChk",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "col-50",
            sortable: true,
          },
          {
            key: "actionEdit",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "col-100",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center col-100",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-left col-100",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-left col-100",
            sortable: true,
          },
          {
            key: "ERRORCONFIG",
            label: this.$t("messages.general.canceledConditions"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-right col-100",
            sortable: true,
          },
          {
            key: "ERRORLIST",
            label: this.$t("messages.general.errorList"),
            thClass: "align-middle",
            tdClass: "text-right col-100",
            sortable: true,
          },
        ],
      },
      bTableStudent: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "editaction",
            label: "",
            thClass: "align-middle",
            tdClass: "col-50",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            thStyle: "width: 230px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            tdClass: "col-50",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      currentPage: 1,
      currentPageSearch: 1,
      currentPageProgram: 1,
      dlgSearchStudentId: "",
      dlgSearchStudentName: "",
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMCODE",
            label: this.$t("messages.general.programcode"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMNAME",
            label: this.$t("messages.general.programName"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMYEAR",
            label: this.$t("messages.general.yearRef"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableConditionlist: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "ERRORID",
            label: this.$t("messages.general.idCondition"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "ERRORSTRING",
            label: this.$t("messages.general.condition"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "ERROR_DETAIL",
            label: this.$t("messages.general.moreDetail"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "ABORTTYPE",
            label: this.$t("messages.general.cancel"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-cencel text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableSearch: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTID",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "FULLNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 200px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTGROUPNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 200px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      searchSelIdx: 0,
      selectedStudentIdx: 0,
      selectedStudent: false,
      programs: [],
      studentConditonList: [],
      studentIdexcelList: [],
      dlgProgramCode: "",
      dlgProgramName: "",
      selFacultyProgram: 0,
      selDepartmentProgram: 0,
      selLvlProgram: 0,
      selYearProgram: 0,
      txtProgramCode: "",
      txtProgramName: "",
      programSelIdx: 0,
      chkCondition: false,
      studentCodeMode: "",
      txtStudentCodeFrom: "",
      txtStudentNameFrom: "",
      txtStudentCodeTo: "",
      txtStudentNameTo: "",
      mode: "",
      selItem: 0,
      masterConditionList: [],
      classId: 0,
      courseId: 0,
      courseCode: "",
      courseName: "",
      classId2: 0,
      courseId2: 0,
      courseCode2: "",
      courseName2: "",
      selErrorId: -1,
      selErrorItem: false,
      errorCMCNTxt: "",
      conditionIdx: 0,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  async mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selLvl = 3;
    const params = {
      token: this.token,
      request: {
        levelid: this.selLvl,
        lang: this.currentLang,
      },
    };
    const result = await enrollProvider.getCurrentyearbylevelid(params);
    this.selYear =
      result.length == 0
        ? this.appInfo.data.ENROLL_ACADYEAR
        : result[0].CURRENTACADYEAR;
    this.selSemester =
      result.length == 0
        ? this.appInfo.data.ENROLL_SEMESTER
        : result[0].CURRENTSEMESTER;
    this.selLvlSearch = 3;
    this.selItem = 0;
    this.selTab = "tab-1";
    await this.getConditionlist();
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "tokenHealthChk",
      "setStudentInfo",
    ]),
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    async handleCourseSearch() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableProgramCourse.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgramCourse.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    handleClrScreen() {
      this.courseId = 0;
      this.courseCode = "";
      this.courseName = "";
    },
    handleClrScreen2() {
      this.courseId2 = 0;
      this.courseCode2 = "";
      this.courseName2 = "";
    },
    clearCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgramCourse.items = [];
    },
    async handleSelectCourse(item, idx) {
      this.handleSelectClassCourse(item); //ส่งค่า courseid ปุ่มฟ้า
      this.conditionIdx = 0;
      this.dialogSearchProgramCourse = false;
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
    },
    async handleSelectClassCourse(item) {
      if (item && item.COURSECODE !== null) {
        if (this.conditionIdx === 1) {
          this.classId = item.CLASSID;
          this.courseId = item.CLASSID;
          this.courseCode = item.COURSECODE;
          this.courseName = item.COURSENAME;
        } else {
          this.classId2 = item.CLASSID;
          this.courseId2 = item.CLASSID;
          this.courseCode2 = item.COURSECODE;
          this.courseName2 = item.COURSENAME;
        }
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        const tmp = [
          {
            text: this.$t("messages.general.notSpecified"),
            value: "00",
          },
        ];
        data.forEach((d) => {
          tmp.push({
            text: d.SECTION_TEXT,
            value: d.SECTION_TEXT,
          });
        });
        this.items = tmp;

        this.togglePreLoader(false);
      }
    },
    async openDialogSearch(mode) {
      this.togglePreLoader(true);
      if (this.txtStudentCodeFrom != "" && mode == "from") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeFrom,
          mode
        );
        if (result) {
          this.txtStudentCodeFrom = result.code;
          this.txtStudentNameFrom = result.name;
        } else {
          this.txtStudentNameFrom = "";
        }
      } else if (this.txtStudentCodeTo != "" && mode == "to") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeTo,
          mode
        );
        if (result) {
          this.txtStudentCodeTo = result.code;
          this.txtStudentNameTo = result.name;
        } else {
          this.txtStudentNameTo = "";
        }
      } else {
        this.cleartSearchStudentCode();
        this.dialogSearch = true;
        this.studentCodeMode = mode;
      }
      this.togglePreLoader(false);
    },
    async openDialogStudentInfo(data, idx) {
      this.togglePreLoader(true);
      this.selectedStudentIdx = idx;
      this.selectedStudent = data;
      this.togglePreLoader(false);
    },
    async onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.getCurrentyearbylevelid(params);
      this.selYear =
        result.length == 0
          ? this.appInfo.data.ENROLL_ACADYEAR
          : result[0].CURRENTACADYEAR;
      this.selSemester =
        result.length == 0
          ? this.appInfo.data.ENROLL_SEMESTER
          : result[0].CURRENTSEMESTER;
    },
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelDepartmentChanged(event) {
      this.selDepartment = parseInt(event.target.value);
    },
    onSelFacultySearchChanged(event) {
      this.selFacultySearch = parseInt(event.target.value);
    },
    onSelDepartmentSearchChanged(event) {
      this.selDepartmentSearch = parseInt(event.target.value);
    },
    onSelLvlSearchChanged(event) {
      this.selLvlSearch = parseInt(event.target.value);
    },
    onSelStudentStatusSearchFromChanged(event) {
      this.selStudentStatusSearchFrom = parseInt(event.target.value);
    },
    onSelStudentStatusSearchToChanged(event) {
      this.selStudentStatusSearchTo = parseInt(event.target.value);
    },
    onSelFacultyProgramChanged(event) {
      this.selFacultyProgram = parseInt(event.target.value);
    },
    onSelDepartmentProgramChanged(event) {
      this.selDepartmentProgram = parseInt(event.target.value);
    },
    onSelLvlProgramChanged(event) {
      this.selLvlProgram = parseInt(event.target.value);
    },
    onSelYearProgramChanged(event) {
      this.selYearProgram = parseInt(event.target.value);
    },
    onSelYearPlanChanged(event) {
      this.selYearPlan = parseInt(event.target.value);
    },
    onSelPrevTermChanged(event) {
      this.selPrevTerm = parseInt(event.target.value);
    },

    handleSelectStudent(data, idx) {
      this.searchSelIdx = idx;
      if (this.studentCodeMode == "from") {
        this.txtStudentCodeFrom = data.STUDENTCODE;
        this.txtStudentNameFrom = data.FULLNAME;
      } else {
        this.txtStudentCodeTo = data.STUDENTCODE;
        this.txtStudentNameTo = data.FULLNAME;
      }
      this.dialogSearch = false;
    },
    goBack() {
      this.selected = false;
      this.selectedIdx = 0;
      this.selectedDetail = false;
      this.isEdit = false;
      this.mode = "";
      this.classId = 0;
      this.courseId = 0;
      this.courseCode = "";
      this.courseName = "";
      this.classId2 = 0;
      this.courseId2 = 0;
      this.courseCode2 = "";
      this.courseName2 = "";
      this.selErrorId = -1;
      this.selErrorItem = false;
      this.studentConditonList = [];
      this.studentIdexcelList = [];
      this.handleSearchConfirmResult();
    },
    goBackIncrease() {
      this.clearSearchProgram();
      this.clearSearchStudentCode();
      this.clearSelectProgram();
      this.clearStudentFrom();
      this.clearStudentTo();
      this.selLvl = 3;
      this.selYearPlan = 0;
      this.selPrevTerm = 0;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selectedYear = 0;
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.mode = "";
      this.classId = 0;
      this.courseId = 0;
      this.courseCode = "";
      this.courseName = "";
      this.classId2 = 0;
      this.courseId2 = 0;
      this.courseCode2 = "";
      this.courseName2 = "";
      this.selErrorId = -1;
      this.selErrorItem = false;
      this.chkCondition = false;
    },
    clearSelectProgram() {
      this.txtProgramCode = "";
      this.txtProgramName = "";
    },
    async handleCsvFileChg(e) {
      var file = e.target.files[0];
      const data = await file.arrayBuffer();
      const workbook = read(data);
      if (workbook && workbook.SheetNames.length > 0) {
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const sheetJson = utils.sheet_to_json(worksheet);
        if (sheetJson) {
          const studentIdexcelList = sheetJson.map((s, idx) => {
            var keyNames = Object.keys(s);
            return { rowNumber: idx + 1, STUDENTCODE: s[keyNames[0]] };
          });
          this.bTableStudentFlieExcelList.items = studentIdexcelList;
        }
      }
      this.goTo(-1, -1, "editFlie");
    },
    async handleSearchProgramKey(event) {
      if (event.charCode == 13) {
        this.dlgProgramCode = this.txtProgramCode;
        this.handleProgramSearch(false);
      }
    },
    async handleProgramSearch(isPopup) {
      const result = await this.getPrograms();
      if (result.length > 0) {
        if (
          !isPopup &&
          (result.length == 1 || result[0].PROGRAMCODE == this.txtProgramCode)
        ) {
          this.txtProgramCode = result[0].PROGRAMCODE;
          this.txtProgramName = result[0].PROGRAMNAME;
        } else {
          this.dialogSearchProgram = true;
          this.bTableProgram.items = [];
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTableProgram.items.push(d);
            idx++;
          });
        }
      } else {
        this.dialogSearchProgram = true;
        this.bTableProgram.items = [];
      }
    },
    handleSearchProgram() {
      this.clearSearchProgram();
      this.dialogSearchProgram = true;
    },
    handleSelectProgram(data, idx) {
      this.programSelIdx = idx;
      this.txtProgramCode = data.PROGRAMCODE;
      this.txtProgramName = data.PROGRAMNAME;
      this.dialogSearchProgram = false;
      this.clearSearchProgram();
    },
    clearSearchProgram() {
      this.dlgProgramCode = "";
      this.dlgProgramName = "";
      this.selFacultyProgram = 0;
      this.selDepartmentProgram = 0;
      this.selLvlProgram = 3;
      this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
      this.bTableProgram.items = [];
    },
    async getPrograms() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          lang: this.currentLang,
          programyear: this.selYearProgram,
          levelid: this.selLvl,
        },
      };
      if (this.selFacultyProgram != 0) {
        params.request.facultyid = this.selFacultyProgram;
      }
      if (this.selDepartmentProgram != 0) {
        params.request.departmentid = this.selDepartmentProgram;
      }
      if (this.dlgProgramCode != "") {
        params.request.programcode = this.dlgProgramCode;
      }
      if (this.dlgProgramName != "") {
        params.request.programname = this.dlgProgramName;
      }
      const result = await enrollProvider.getSearchProgram(params);
      this.togglePreLoader(false);
      return result;
    },
    increase() {
      this.goTo(-1, -1, "increase");
      this.clearSearchProgram();
      this.clearSearchStudentCode();
      this.clearSelectProgram();
      this.clearStudentFrom();
      this.clearStudentTo();
      this.selLvl = 3;
      this.selYearPlan = 0;
      this.selPrevTerm = 0;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selectedYear = 0;
      this.chkCondition = false;
    },
    handleTableEdit(item, index, mode) {
      this.selected = item;
      this.selectedIdx = index;
      this.studentConditonList.push(item);
      this.studentConditonList[0].rowNumber = 1;
      this.bTableStuList.items = this.studentConditonList;

      this.goTo(item, index, mode);
    },
    goTo(item, index, mode) {
      this.mode = mode;
      if (mode == "edit") {
        if (this.studentConditonList.length <= 1) {
          this.selTab = "tab-1";
          this.getConditionlistByStudent();
          this.getAdjustconditionerror();
        }
      }
      if (mode == "editFlie") {
        console.log("editFlie");
      } else {
        console.log("increase");
      }
    },
    async getConditionlist() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getconditionlist({
        token: this.token,
        request: {
          lang: this.currentLang,
        },
      });
      this.masterConditionList = [];
      if (result.length > 0) {
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          d.ERROR_DETAIL = d.ERROR_DETAIL == null ? "" : d.ERROR_DETAIL;
          this.masterConditionList.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    //รายการ error ที่ข้ามของ นศ >tabเงื่อนไขที่ได้รับการยกเลิกหน้าedit
    async getConditionlistByStudent() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getConditionlistbystd({
        token: this.token,
        request: {
          studentid: this.selected.STUDENTCODE,
          lang: this.currentLang,
        },
      });
      this.bTableConditionlistbystd.items = [];

      if (result.length > 0) {
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          const foundCondition = this.masterConditionList.find(
            (m) => m.ERRORID == d.ERRORID
          );
          if (foundCondition) {
            d.ERRORSTRING = foundCondition.ERRORSTRING;
            const temp = "";
            if (
              (foundCondition.ERROR_DETAIL == "C1" ||
                foundCondition.ERROR_DETAIL == "C2") &&
              foundCondition.ERRORID != 5103
            ) {
              d.ERROR_DETAIL = `${d.COURSECODE1}${
                d.COURSECODE2 != null && d.COURSECODE2 != ""
                  ? ", " + d.COURSECODE2
                  : ""
              }`;
            }
            if (
              foundCondition.ERROR_DETAIL == "C2" &&
              foundCondition.ERRORID != 5103
            ) {
              d.ERROR_DETAIL = d.COURSECODE2;
            }
            if (
              foundCondition.ERROR_DETAIL == "C2" &&
              (foundCondition.ERRORID == 5102 ||
                foundCondition.ERRORID == 5103 ||
                foundCondition.ERRORID == 5108)
            ) {
              d.ERROR_DETAIL = `${d.COURSECODE1}, ${d.COURSECODE2}`;
            }
            if (foundCondition.ERROR_DETAIL == "CN") {
              d.ERROR_DETAIL = d.CREDITMIN;
            }
            if (foundCondition.ERROR_DETAIL == "CM") {
              d.ERROR_DETAIL = d.CREDITMAX;
            }
          } else {
            d.ERRORSTRING = "";
          }

          this.bTableConditionlistbystd.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    //รายการ error ที่เกิดขึ้น >tabรายการerrorที่เกิดขึ้นหน้าedit
    async getAdjustconditionerror() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getAdjustconditionerror({
        token: this.token,
        request: {
          studentid: this.selected.STUDENTCODE,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableConditionerror.items = [];
      if (result.length > 0) {
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableConditionerror.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    async handleDeleteConditionbyStd(data) {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const res = await enrollProvider.delClearadjustcondition({
        token: this.token,
        request: {
          studentid: data.item.STUDENTCODE,
          errorid: data.item.ERRORID,
          acadyear: this.selYear,
          semester: this.selSemester,
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.getConditionlistByStudent();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    handleChkAllStudent(e) {
      const isChecked = e.target.checked;
      this.bTable.items.map((i) => {
        i.selCheck = isChecked;
        if (isChecked) {
          this.studentConditonList.push(i);
        }
      });
      if (!isChecked) {
        this.studentConditonList = [];
      }
    },
    handleChkStudent(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTable.items.forEach((e) => {
        if (e.rowNumber == item.rowNumber) {
          e.selCheck = isChecked;
        }
      });
      if (isChecked) {
        this.studentConditonList.push(item);
      } else {
        const newArr = this.studentConditonList.filter(
          (s) => s.STUDENTCODE != item.STUDENTCODE
        );
        this.studentConditonList = newArr;
      }
    },
    async handleDeleteStuError(data) {
      this.togglePreLoader(true);
      let listErrMsg = "";
      let resMsg = "";
      const resIp = await masterDataProvider.getCurrentIP();
      const arrErrorId = data.item.ERRORCONFIG.split(",");
      if (arrErrorId.length > 0) {
        for (let i = 0; i < arrErrorId.length; i++) {
          const item = arrErrorId[i];
          const res = await enrollProvider.delClearadjustcondition({
            token: this.token,
            request: {
              studentid: data.item.STUDENTCODE,
              errorid: item,
              acadyear: this.selYear,
              semester: this.selSemester,
              ipaddress: resIp.ip,
              userid: this.mfuUserId,
              lang: this.currentLang,
            },
          });
          if (res.status != 200) {
            listErrMsg += `${res.message}<br/>`;
          }
        }
      }
      this.togglePreLoader(false);
      if (listErrMsg == "") {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        // this.successText = `${resMsg}<br/>`;
        this.handleSearchConfirmResult();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${listErrMsg}<br/>`;
      }
    },
    async handleSearchConfirmResult() {
      if (this.selLvl != -1) {
        this.togglePreLoader(true);
        const result = await enrollProvider.getAdjustcondition({
          token: this.token,
          request: {
            admitacadyear: this.selYearPlan,
            admitsemester: this.selPrevTerm,
            levelid: this.selLvl,
            studentyear: this.selectedYear,
            facultyid: this.selFaculty,
            departmentid: this.selDepartment,
            programid: this.txtProgramCode,
            studentidfrom: this.txtStudentCodeFrom,
            studentidto: this.txtStudentCodeTo,
            conapprove: this.chkCondition ? 1 : 0,
            lang: this.currentLang,
          },
        });
        this.bTable.items = [];
        if (result.length > 0) {
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            d.ERRORCONFIG = d.ERRORCONFIG.replace(/,/g, ", ");
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResultStudent() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getAdjustconditionadd({
        token: this.token,
        request: {
          admitacadyear: this.selYearPlan,
          admitsemester: this.selPrevTerm,
          levelid: this.selLvl,
          studentyear: this.selectedYear,
          facultyid: this.selFaculty,
          departmentid: this.selDepartment,
          programid: this.txtProgramCode,
          studentidfrom: this.txtStudentNameFrom,
          studentidto: this.txtStudentCodeTo,
          lang: this.currentLang,
        },
      });
      this.bTableStudent.items = [];
      if (result.length > 0) {
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableStudent.items.push(d);
          idx++;
        });
      }
      this.showListCondition();
      this.togglePreLoader(false);
    },
    async showListCondition() {
      this.togglePreLoader(true);
      this.bTableConditionsCtrlEnroll.items = [];
      await this.getConditionlist();
      this.bTableConditionsCtrlEnroll.items = this.masterConditionList;
      this.togglePreLoader(false);
    },
    async handleSearchStudentCode() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang,
        },
      };
      if (this.dlgSearchStudentId != 0) {
        params.request.studentcode = this.dlgSearchStudentId;
      }
      if (this.dlgSearchStudentName != "") {
        params.request.studentname = this.dlgSearchStudentName;
      }
      if (this.selFacultySearch != 0) {
        params.request.facultyid = this.selFacultySearch;
      }
      if (this.selDepartmentSearch != 0) {
        params.request.departmentid = this.selDepartmentSearch;
      }
      if (this.selStudentStatusSearchFrom != 0) {
        params.request.studentstatusfrom = this.selStudentStatusSearchFrom;
      }
      if (this.selStudentStatusSearchTo != 0) {
        params.request.studentstatusto = this.selStudentStatusSearchTo;
      }
      const result = await enrollProvider.searchStudentCode(params);
      this.bTableSearch.items = [];
      if (result.length > 0) {
        let idx = 0;
        if (!result[idx].hasOwnProperty("ERR_DESC")) {
          result.map((d) => {
            d.rowNumber = idx + 1;
            d.FULLNAME = `${d.PREFIXNAME} ${d.STUDENTNAME} ${d.STUDENTSURNAME}`;
            this.bTableSearch.items.push(d);
            idx++;
          });
        }
      }
      this.togglePreLoader(false);
    },
    async handleSaveFlieAdjustConditionlist() {
      if (this.selErrorId != -1 && this.selErrorItem) {
        if (
          (this.selErrorItem.ERROR_DETAIL == "CM" ||
            this.selErrorItem.ERROR_DETAIL == "CN") &&
          this.errorCMCNTxt == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID != 5103 &&
          this.courseId == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID == 5101 &&
          this.courseId2 == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C2" &&
          this.selErrorItem.ERRORID != 5103 &&
          this.courseId2 == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID == 5103 &&
          this.classId == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C2" &&
          this.selErrorItem.ERRORID == 5103 &&
          this.classId2 == ""
        ) {
          return;
        }
        this.togglePreLoader(true);

        this.studentIdexcelList = this.bTableStudentFlieExcelList.items;
        const tmpStuList = this.studentIdexcelList.map((d) => {
          return +d.STUDENTCODE;
        });

        const req = {
          token: this.token,
          request: {
            studentidlist: tmpStuList,
            erroridlist: [+this.selErrorId],
            courseid1:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID != 5103
                ? this.courseId
                : "",
            courseid2:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID != 5103
                ? this.courseId2
                : "",
            creditmin:
              this.selErrorItem.ERROR_DETAIL == "CN" ? this.errorCMCNTxt : "",
            creditmax:
              this.selErrorItem.ERROR_DETAIL == "CM" ? this.errorCMCNTxt : "",
            classid1:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID == 5103
                ? this.classId
                : "",
            classid2:
              this.selErrorItem.ERROR_DETAIL == "C2" &&
              this.selErrorItem.ERRORID == 5103
                ? this.classId2
                : "",
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        };
        const result = await enrollProvider.postAdjustConditionList(req);
        this.togglePreLoader(false);
        if (result.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${result.message}<br/>`;
          this.selErrorId = -1;
          this.selErrorItem = false;
          this.classId = 0;
          this.courseId = 0;
          this.courseCode = "";
          this.courseName = "";
          this.classId2 = 0;
          this.courseId2 = 0;
          this.courseCode2 = "";
          this.courseName2 = "";
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${result.message}`;
        }
      }
    },
    async handleSaveAdjustCondition() {
      if (this.selErrorId != -1 && this.selErrorItem) {
        if (
          (this.selErrorItem.ERROR_DETAIL == "CM" ||
            this.selErrorItem.ERROR_DETAIL == "CN") &&
          this.errorCMCNTxt == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID != 5103 &&
          this.courseId == ""
        ) {
          return;
        }
        // if (
        //   this.selErrorItem.ERROR_DETAIL == "C1" &&
        //   this.selErrorItem.ERRORID == 5101 &&
        //   this.courseId2 == ""
        // ) {
        //   return;
        // }
        if (
          this.selErrorItem.ERROR_DETAIL == "C2" &&
          this.selErrorItem.ERRORID != 5103 &&
          this.courseId2 == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID == 5103 &&
          this.classId == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C2" &&
          this.selErrorItem.ERRORID == 5103 &&
          this.classId2 == ""
        ) {
          return;
        }
        this.togglePreLoader(true);
        const tmpStuList = this.studentConditonList.map((d) => {
          return +d.STUDENTCODE;
        });
        const req = {
          token: this.token,
          request: {
            studentidlist: tmpStuList,
            erroridlist: [+this.selErrorId],
            courseid1:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID != 5103
                ? this.courseId
                : "",
            courseid2:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID != 5103
                ? this.courseId2
                : "",
            creditmin:
              this.selErrorItem.ERROR_DETAIL == "CN" ? this.errorCMCNTxt : "",
            creditmax:
              this.selErrorItem.ERROR_DETAIL == "CM" ? this.errorCMCNTxt : "",
            classid1:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID == 5103
                ? this.classId
                : "",
            classid2:
              this.selErrorItem.ERROR_DETAIL == "C2" &&
              this.selErrorItem.ERRORID == 5103
                ? this.classId2
                : "",
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        };
        const result = await enrollProvider.postAdjustConditionList(req);
        this.togglePreLoader(false);
        if (result.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${result.message}<br/>`;
          this.selErrorId = -1;
          this.selErrorItem = false;
          this.classId = 0;
          this.courseId = 0;
          this.courseCode = "";
          this.courseName = "";
          this.classId2 = 0;
          this.courseId2 = 0;
          this.courseCode2 = "";
          this.courseName2 = "";
          if (this.studentConditonList.length <= 1) {
            this.getConditionlistByStudent();
          }
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${result.message}`;
        }
      }
    },
    async handleChkSetStudent() {
      const tmp = this.studentConditonList.map((d, idx) => {
        return {
          ...d,
          rowNumber: idx + 1,
        };
      });
      this.bTableStuList.items = tmp;
      this.goTo(false, 0, "edit");
    },
    async handleClearDataTablePopup() {
      this.dialogConfirmDeleteTable = true;
    },
    async handleClearDataTable() {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const res = await enrollProvider.delClearadjustcondition({
        token: this.token,
        request: {
          studentid: 0,
          errorid: 0,
          acadyear: this.selYear,
          semester: this.selSemester,
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.handleSearchConfirmResult();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },

    cleartSearchStudentCode() {
      this.studentCodeMode = "";
      this.dlgSearchStudentId = "";
      this.dlgSearchStudentName = "";
      this.selFacultySearch = 0;
      this.selDepartmentSearch = 0;
      this.selLvlSearch = 3;
      this.selStudentStatusSearchFrom = 0;
      this.selStudentStatusSearchTo = 0;
      this.bTableSearch.items = [];
    },
    clearAll() {
      this.clearSearchProgram();
      this.clearSearchStudentCode();
      this.clearSelectProgram();
      this.clearStudentFrom();
      this.clearStudentTo();
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selYearPlan = 0;
      this.selPrevTerm = 0;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selectedYear = 0;
      this.chkCondition = false;
    },
    clearAllIncrease() {
      this.clearSearchProgram();
      this.clearSearchStudentCode();
      this.clearSelectProgram();
      this.clearStudentFrom();
      this.clearStudentTo();
      this.selLvl = 3;
      this.selYearPlan = 0;
      this.selPrevTerm = 0;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selectedYear = 0;
    },

    clearSearchStudentCode() {
      this.studentCodeMode = "";
      this.dlgSearchStudentId = "";
      this.dlgSearchStudentName = "";
      this.selFacultySearch = 0;
      this.selDepartmentSearch = 0;
      this.selLvlSearch = 3;
      this.selStudentStatusSearchFrom = 0;
      this.selStudentStatusSearchTo = 0;
      this.bTableSearch.items = [];
    },
    clearStudentFrom() {
      this.txtStudentCodeFrom = "";
      this.txtStudentNameFrom = "";
    },
    clearStudentTo() {
      this.txtStudentCodeTo = "";
      this.txtStudentNameTo = "";
    },
    handleDelChkAll(e) {
      const isChecked = e.target.checked;
      this.bTable.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.studentUnapproveList.push(i.STUDENTID);
        }
      });
      if (!isChecked) {
        this.studentUnapproveList = [];
      }
    },
    handleDelChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTable.items[index].action = isChecked;
      if (isChecked) {
        this.studentUnapproveList.push(item.CLASSID);
      } else {
        const newArr = this.studentUnapproveList.filter(
          (s) => s != item.STUDENTID
        );
        this.studentUnapproveList = newArr;
      }
    },
    handleChkStuAll(e) {
      const isChecked = e.target.checked;
      this.bTableStudent.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.studentUnapproveListAdd.push(i.STUDENTID);
        }
      });
      if (!isChecked) {
        this.studentUnapproveListAdd = [];
      }
    },
    handleChkStu(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableStudent.items[index].action = isChecked;
      if (isChecked) {
        this.studentUnapproveListAdd.push(item.CLASSID);
      } else {
        const newArr = this.studentUnapproveListAdd.filter(
          (s) => s != item.STUDENTID
        );
        this.studentUnapproveListAdd = newArr;
      }
    },
    async handleSelect(data, idx) {
      this.selItem = idx;
      const menus = await masterDataProvider.getMenu({
        token: this.token,
        userId: data.STUDENTID,
        lang: this.currentLang,
      });
      this.setStudentInfo({
        studentId: data.STUDENTID,
        data: data,
        menus: menus,
      });
      this.$router.push("/");
    },
    async handleSearchStudentFromKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeFrom != "") {
        this.handleSearchStudentKey(this.txtStudentCodeFrom, "from");
      }
    },
    async handleSearchStudentToKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeTo != "") {
        this.handleSearchStudentKey(this.txtStudentCodeTo, "to");
      }
    },
    async handleSearchStudentKey(code, mode) {
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang,
        },
      };

      params.request.studentcode = code;
      this.studentCodeMode = mode;
      this.togglePreLoader(true);
      const result = await enrollProvider.searchStudentCode(params);
      this.togglePreLoader(false);

      if (
        mode == "from" &&
        result.length > 0 &&
        (result.length == 1 || result[0].STUDENTCODE == code)
      ) {
        this.txtStudentCodeFrom = result[0].STUDENTCODE;
        this.txtStudentNameFrom = `${result[0].PREFIXNAME}${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`;
      } else if (
        mode == "to" &&
        result.length > 0 &&
        (result.length == 1 || result[0].STUDENTCODE == code)
      ) {
        this.txtStudentCodeTo = result[0].STUDENTCODE;
        this.txtStudentNameTo = `${result[0].PREFIXNAME}${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`;
      } else {
        this.dlgSearchStudentId =
          mode == "from" ? this.txtStudentCodeFrom : this.txtStudentCodeTo;
        this.dialogSearch = true;
        this.handleSearchStudentCode();
      }
    },
    handleSelErrChg(e) {
      const found = this.masterConditionList.find(
        (m) => m.ERRORID == e.target.value
      );
      if (found) {
        this.selErrorId = found.ERRORID;
        this.selErrorItem = found;
        this.classId = 0;
        this.courseId = 0;
        this.courseCode = "";
        this.courseName = "";
        this.classId2 = 0;
        this.courseId2 = 0;
        this.courseCode2 = "";
        this.courseName2 = "";
        this.errorCMCNTxt = "";
      } else {
        this.selErrorId = -1;
        this.selErrorItem = false;
      }
    },
    handleSelectClass(item, idx) {
      if (item && item.COURSECODE !== null) {
        if (idx == 1) {
          this.classId = item.CLASSID;
          this.courseId = item.COURSEID;
          // this.courseCode = `${item.COURSECODE}: ${item.COURSENAME}`;
          this.courseCode = `${item.COURSECODE}`;
          this.courseName = item.COURSENAME;
        } else {
          this.classId2 = item.CLASSID;
          this.courseId2 = item.COURSEID;
          // this.courseCode2 = `${item.COURSECODE}: ${item.COURSENAME}`;
          this.courseCode2 = `${item.COURSECODE}`;
          this.courseName2 = item.COURSENAME;
        }
      }
    },
    async handleSearchCls(idx) {
      this.conditionIdx = idx;
      if (
        (this.courseCode != "" && idx == 1) ||
        (this.courseCode2 != "" && idx == 2)
      ) {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: idx == 1 ? this.courseCode : this.courseCode2,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        if (result.data.length > 0) {
          if (result.code != 500 && result.data.length === 1) {
            this.handleSelectClass(result.data[0], idx);
            this.courseList = result;
          } else {
            this.courseList = result;
            // this.dlgCourseCode = this.courseCode;
            this.dlgCourseCode = idx == 1 ? this.courseCode : this.courseCode2;
            this.dialogSearchProgramCourse = true;
            this.bTableProgramCourse.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgramCourse.items.push(d);
                idx++;
              });
            }
          }
        }
        this.togglePreLoader(false);
      } else {
        this.bTableProgramCourse.items = [];
        this.courseList = [];
        this.dialogSearchProgramCourse = true;
      }
    },
    handleSearchClsKey(event, idx) {
      if (event.charCode == 13 || event.charCode == 9) {
        this.handleSearchCls(idx);
      }
    },
    async handleSaveErrorCondition() {
      const studentSelList = this.bTableStudent.items.filter(
        (i) => i.action == true
      );
      if (studentSelList.length <= 0) {
        return;
      }
      if (this.selErrorId != -1 && this.selErrorItem) {
        if (
          (this.selErrorItem.ERROR_DETAIL == "CM" ||
            this.selErrorItem.ERROR_DETAIL == "CN") &&
          this.errorCMCNTxt == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID != 5103 &&
          this.courseId == ""
        ) {
          return;
        }
        // if (
        //   this.selErrorItem.ERROR_DETAIL == "C1" &&
        //   this.selErrorItem.ERRORID == 5101 &&
        //   this.courseId2 == ""
        // ) {
        //   return;
        // }
        if (
          this.selErrorItem.ERROR_DETAIL == "C2" &&
          this.selErrorItem.ERRORID != 5103 &&
          this.courseId2 == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C1" &&
          this.selErrorItem.ERRORID == 5103 &&
          this.classId == ""
        ) {
          return;
        }
        if (
          this.selErrorItem.ERROR_DETAIL == "C2" &&
          this.selErrorItem.ERRORID == 5103 &&
          this.classId2 == ""
        ) {
          return;
        }
        this.togglePreLoader(true);
        const req = {
          token: this.token,
          request: {
            studentidlist: studentSelList.map((ii) => +ii.STUDENTCODE),
            erroridlist: [+this.selErrorId],
            courseid1:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID != 5103
                ? this.courseId
                : "",
            courseid2:
             (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID != 5103
                ? this.courseId2
                : "",
            creditmin:
              this.selErrorItem.ERROR_DETAIL == "CN" ? this.errorCMCNTxt : "",
            creditmax:
              this.selErrorItem.ERROR_DETAIL == "CM" ? this.errorCMCNTxt : "",
            classid1:
              (this.selErrorItem.ERROR_DETAIL == "C1" ||
                this.selErrorItem.ERROR_DETAIL == "C2") &&
              this.selErrorItem.ERRORID == 5103
                ? this.classId
                : "",
            classid2:
              this.selErrorItem.ERROR_DETAIL == "C2" &&
              this.selErrorItem.ERRORID == 5103
                ? this.classId2
                : "",
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        };

        const result = await enrollProvider.postAdjustConditionList(req);
        this.togglePreLoader(false);
        if (result.status == 200) {
          this.dialogConfirmSuccess = true;
          this.successText = `${result.message}<br/>`;
          this.selErrorId = -1;
          this.selErrorItem = false;
          this.classId = 0;
          this.courseId = 0;
          this.courseCode = "";
          this.courseName = "";
          this.classId2 = 0;
          this.courseId2 = 0;
          this.courseCode2 = "";
          this.courseName2 = "";
          this.studentUnapproveListAdd = [];
          const filterTemp = this.bTableStudent.items.map((b) => {
            return {
              ...b,
              action: false,
            };
          });
          this.bTableStudent.items = filterTemp;
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${result.message}`;
        }
      }
    },
  },
  watch: {
    async currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMCODE",
          label: this.$t("messages.general.programcode"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMNAME",
          label: this.$t("messages.general.programName"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMYEAR",
          label: this.$t("messages.general.yearRef"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableSearch.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTID",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "FULLNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 200px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTGROUPNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 200px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableStudentFlieExcelList.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
      ];
      this.bTableStuList.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "actionChk",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "col-500",
          sortable: true,
        },
        {
          key: "actionEdit",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "col-100",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center col-100",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-left col-100",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-left col-100",
          sortable: true,
        },
        {
          key: "ERRORCONFIG",
          label: this.$t("messages.general.canceledConditions"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-right col-100",
          sortable: true,
        },
        {
          key: "ERRORLIST",
          label: this.$t("messages.general.errorList"),
          thClass: "align-middle",
          tdClass: "text-right col-100",
          sortable: true,
        },
      ];
      this.bTableProgramCourse.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableConditionlist.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "ERROR_DETAIL",
          label: this.$t("messages.general.moreDetail"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "ABORTTYPE",
          label: this.$t("messages.general.cancel"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-cencel text-nowarp",
          sortable: true,
        },
      ];
      this.bTableConditionerror.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          sortable: true,
        },
      ];
      this.bTableStudent.fields = [
        {
          key: "editaction",
          label: "",
          thClass: "align-middle",
          tdClass: "col-50",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          thStyle: "width: 230px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          tdClass: "col-50",
          sortable: true,
        },
      ];
      this.bTableConditionsCtrlEnroll.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "ERROR_DETAIL",
          label: this.$t("messages.general.moreDetail"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 80px",
          sortable: true,
        },
      ];
      this.bTableConditionlistbystd.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "ERROR_DETAIL",
          label: this.$t("messages.general.moreDetail"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 80px",
          sortable: true,
        },
      ];
      this.selectedYearOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ];
    },
  },
};
</script>
